// extracted by mini-css-extract-plugin
module.exports = {"footer-container":"footer_footer-container__nZlHV"};